// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color, xScreen } from "@plumberssupply/XDL/Utilities";
import React, { } from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductLastOrderedStyles {
    wrapper: InjectableCss;
    text?: TypographyPresentationProps;
}

export const productLastOrderedStyles: ProductLastOrderedStyles = {
    wrapper: {
        css: css`
            margin-bottom: 20px;
            ${xScreen("lte", "sm")} {
                margin-top: 20px;
            }
            ${xScreen("lte", "md")} {
                margin-bottom: 12px;
            }
        `,
    },
    text: {
        size: 12,
        weight: "bold",
        color: "success",
        css: css`
            letter-spacing: 0;
            line-height: 15px;
            background-color: ${color("success.light")};
            border: 1px solid ${color("success")};
            padding: 8px 12px;
            text-align: center;
            display: inline-block;
    `},
};

const ProductLastOrdered: React.FC<Props> = ({ product }) => {
    const styles = productLastOrderedStyles;

    if (((product.properties.isPreviouslyPurchased || "").toLowerCase() === "false") || !product.properties.plumbers_lastOrderedDate) {
        return null;
    }
    const formattedLastOrderedDate = new Date(product.properties.plumbers_lastOrderedDate).toLocaleDateString();

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.text} data-test-selector="ProductPreviousPurchase">
                {translate(`Last Ordered: ${formattedLastOrderedDate}`)}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductLastOrdered),
    definition: {
        displayName: "Product Last Ordered",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
